/**
 * 채팅 승인 카드의 단추 — 서버로 가는 한 줄 (2026-09-21).
 *
 * ★ 카드 재료는 **메시지에 실려 온다**(`attachments.aiConfirm`) — 따로 받아 오지 않는다.
 *   그래서 새로고침해도 카드가 그대로고, 이미 누른 카드는 닫힌 채로 뜬다.
 */
import { apiClient } from './client';

export interface ChatConfirmLine { label: string; value: string }

export interface ChatConfirmCard {
  v: number;
  tool: string;
  severity: string;
  blastRadius: string;
  continuationId: string;
  confirmToken: string;
  whatWillHappen: string;
  expiresAt: number;
  forUserId: string;
  status: 'pending' | 'approved' | 'denied';
  lines: ChatConfirmLine[];
}

/** 메시지 첨부에서 카드를 꺼낸다. 진짜 첨부(배열)와 섞이지 않는다. */
export function readChatConfirmCard(attachments: unknown): ChatConfirmCard | null {
  if (!attachments || typeof attachments !== 'object' || Array.isArray(attachments)) return null;
  const c = (attachments as { aiConfirm?: unknown }).aiConfirm;
  if (!c || typeof c !== 'object' || Array.isArray(c)) return null;
  const card = c as Partial<ChatConfirmCard>;
  if (typeof card.continuationId !== 'string' || typeof card.confirmToken !== 'string') return null;
  if (typeof card.tool !== 'string') return null;
  return {
    v: 1,
    tool: card.tool,
    severity: card.severity ?? 'danger',
    blastRadius: card.blastRadius ?? 'system',
    continuationId: card.continuationId,
    confirmToken: card.confirmToken,
    whatWillHappen: card.whatWillHappen ?? `도구 ${card.tool} 호출`,
    expiresAt: typeof card.expiresAt === 'number' ? card.expiresAt : 0,
    forUserId: String(card.forUserId ?? ''),
    status: card.status === 'approved' || card.status === 'denied' ? card.status : 'pending',
    lines: Array.isArray(card.lines) ? card.lines : [],
  };
}

export interface ChatConfirmResult {
  status: 'approved' | 'denied';
  text: string;
}

export async function decideChatConfirm(
  roomId: string,
  body: {
    messageId: string; continuationId: string; confirmToken: string;
    decision: 'approve' | 'deny';
  },
): Promise<ChatConfirmResult> {
  const { data } = await apiClient.post<ChatConfirmResult>(`/chat/rooms/${roomId}/ai/confirm`, body);
  return data;
}
